import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { useNuxtApp } from "nuxt/app";
export const appConfigStore = defineStore("appConfig", () => {
  const { $api } = useNuxtApp();
  const messages = ref([]);
  const loading = ref({});
  const config = ref({});
  const vars = ref({});
  const getConfig = async () => {
    try {
      const res = await $api.agent.get("/configs");
      config.value = res?._data?.config;
      vars.value = res?._data?.var;
    } catch (e) {
      console.log("Failed to get config", e.response);
    }
  };
  const setLoading = (loadingOpt) => {
    Object.keys(loadingOpt).forEach((key) => {
      loading.value.key = loadingOpt[key];
    });
  };
  const configList = computed(() => config.value);
  const varsList = computed(() => vars.value);
  return {
    config,
    varsList,
    configList,
    loading,
    vars,
    messages,
    getConfig,
    setLoading
  };
});
